// extracted by mini-css-extract-plugin
export default {"card":"categoryCard_card__E4bFk","cardImage":"categoryCard_cardImage__vdmQM","title":"categoryCard_title__mUKby"};